import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';
import {FormViewRowV2} from '../FormViewRow/FormViewRowV2';

export interface FormViewSelectV2Props {
  field: IFormFieldV2;
  value: any;
}

export const FormViewSelectV2: React.FC<FormViewSelectV2Props> = ({
  field,
  value,
}) => {
  // Helper function to get display value for select/autocomplete fields
  const getSelectDisplayValue = (value: any): string => {
    if (!value || !field.options) return value;

    const selectedOption = field.options.find(
      option => String(option.id) === String(value)
    );

    return selectedOption?.label || value;
  };

  return <FormViewRowV2 field={field} value={getSelectDisplayValue(value)} />;
};
